<!-- Sidebar Toggle Button (Hamburger) - Only show when not pinned -->
<button *ngIf="!isPinned"
  class="sidebar-toggle fixed p-2.5 bg-white rounded-lg shadow-lg border border-gray-200 hover:bg-gray-50 transition-all"
  [style.top.px]="16" [style.left.px]="16" [style.z-index]="9999" (click)="toggleSidebar()" aria-label="Toggle menu">
  <i class="fas fa-bars text-gray-700 text-lg" *ngIf="!isOpen"></i>
  <i class="fas fa-times text-gray-700 text-lg" *ngIf="isOpen"></i>
</button>

<!-- Sidebar -->
<aside
  class="sidebar fixed top-0 left-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col"
  [style.z-index]="999" [class.translate-x-0]="isOpen" [class.-translate-x-full]="!isOpen">
  <!-- Sidebar Header -->
  <div class="p-4 border-b border-gray-200 bg-gradient-to-r from-green-600 to-green-500">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <img src="images/logo.png" alt="ClearScrap" class="h-8" />
      </div>
      <button (click)="togglePin()" class="p-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all"
        [title]="isPinned ? 'Unpin sidebar' : 'Pin sidebar'">
        <i class="fas text-white" [class.fa-thumbtack]="!isPinned" [class.fa-times]="isPinned"></i>
      </button>
    </div>
  </div>

  <!-- Sidebar Navigation -->
  <nav class="flex-1 overflow-y-auto py-4">
    <!-- Home Section -->
    <a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-home w-5 text-center mr-3"></i>
      <span>Home</span>
    </a>

    <!-- Voucher Reports Section -->
    <a routerLink="/reports" routerLinkActive="active-link" (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-chart-bar w-5 text-center mr-3"></i>
      <span>Voucher Reports</span>
    </a>

    <!-- Voucher Insights Section -->
    <a routerLink="/insights" routerLinkActive="active-link" (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-chart-line w-5 text-center mr-3"></i>
      <span>Voucher Insights</span>
    </a>

    <!-- Pending Redemptions Section -->
    <a routerLink="/pending-redemptions"
      routerLinkActive="active-link" (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-users-cog w-5 text-center mr-3"></i>
      <span>Pending Redemptions</span>
    </a>

    <!-- Partner Invoices Section -->
    <a *ngIf="permissionService.hasPermission(UserPermission.Partner_ViewInvoices)" routerLink="/invoices"
      routerLinkActive="active-link" (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-file-invoice-dollar w-5 text-center mr-3"></i>
      <span>Partner Invoices</span>
    </a>


    <!-- Revoke Voucher Section -->
    <a routerLink="/revoke" routerLinkActive="active-link" (click)="closeSidebar()"
      class="nav-link flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 transition-all duration-200">
      <i class="fas fa-undo-alt w-5 text-center mr-3"></i>
      <span>Revoke Voucher</span>
    </a>
  </nav>

  <!-- Sidebar Footer -->
  <div class="p-4 border-t border-gray-200 bg-gray-50">
    <div class="text-xs text-gray-500 text-center">
      <i class="fas fa-leaf text-green-600 mr-1"></i>
      ClearScrap Partner Portal
    </div>
  </div>
</aside>